/**
 * 현재 도메인이 소도몰 파트너 도메인인지 확인
 */
export const isSodomallPartnerDomain = (): boolean => {
    if (typeof window === 'undefined') return false;
    const hostname = window.location.hostname;
    return hostname === 'partner.sodomall.store' || hostname === 'partner.dev.sodomall.store';
};

/**
 * 현재 도메인이 *.flowing.space 형태의 도메인인지 확인
 */
export const isFlowingSpaceDomain = (): boolean => {
    if (typeof window === 'undefined') return false;
    const hostname = window.location.hostname;
    return hostname === 'flowing.space' || hostname.endsWith('.flowing.space');
};

